import i18n from '@/plugins/i18n'
import { FORUM_NAVBAR_LAYOUT } from '@/constants/layouts'

function scrollTop(to, from, next) {
    window.scrollTo(0, 0)
    next()
  }

export default [
    {
    name: 'foro',
    path: '/',
    component: () => import('@/components/views/healthy-community/forum/Forum'),
    meta: {
        layout: FORUM_NAVBAR_LAYOUT,
        forumClass: true,
        title: {
            text () {
                return i18n.t('forumTitle')
            }
        },
        i18n: 'public/views/healthy-community'
    },
    beforeEnter: scrollTop
    },
    {
    name: 'panel-administracion',
    path: 'panel/:section?',
    component: () => import('@/components/views/healthy-community/forum/ForumControlPanel'),
    meta: {
        layout: FORUM_NAVBAR_LAYOUT,
        forumClass: true,
        title: {
            text () {
                return i18n.t('forumTitle')
            }
        },
        i18n: 'public/views/healthy-community'
        // roles: [ROLES.PATIENT, ROLES.PROFESSIONAL, ROLES.ADMIN, ROLES.CENTER]
    },
    beforeEnter: scrollTop
    },
    {
        name: 'foro-entry',
        path: 'foro-entry/:entryId?',
        component: () => import('@/components/views/healthy-community/forum/Forum'),
        meta: {
                layout: FORUM_NAVBAR_LAYOUT,
                forumClass: true,
                title: {
                text () {
                                return i18n.t('forumTitle')
                        }
                },
                i18n: 'public/views/healthy-community'
                // roles: [ROLES.PATIENT, ROLES.PROFESSIONAL, ROLES.ADMIN, ROLES.CENTER]
        }
    },
    {
        name: 'hilo-foro',
        path: ':id',
        component: () => import('@/components/views/healthy-community/forum/ForumThread'),
        meta: {
                layout: FORUM_NAVBAR_LAYOUT,
                forumClass: true,
                title: {
                text () {
                                return i18n.t('forumTitle')
                        }
                },
                i18n: 'public/views/healthy-community'
                // roles: [ROLES.PATIENT, ROLES.PROFESSIONAL, ROLES.ADMIN, ROLES.CENTER]
        },
        beforeEnter: scrollTop
    }
  ]


// WEBPACK FOOTER //
// ./src/router/routes/webapp/forum.routes.js